import { render, staticRenderFns } from "./ForgotPassword.html?vue&type=template&id=5e84cfda&scoped=true&external"
import script from "./ForgotPassword.js?vue&type=script&lang=js&external"
export * from "./ForgotPassword.js?vue&type=script&lang=js&external"
import style0 from "./ForgotPassword.scss?vue&type=style&index=0&id=5e84cfda&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e84cfda",
  null
  
)

export default component.exports